import { useOrganization } from '@hooks/queries/useOrganization';
import { useLivePathname } from '@hooks/useLivePathname';
import { matchPath, useParams } from 'react-router';

const WORKSPACE_HALL_PATTERN = '/app/organizations/workspace/:workspaceId/*';

// Not the hall's selected-entity store: that keeps the last workspace on the listing itself.
export function useWorkspaceId(): string | undefined {
  const pathname = useLivePathname();
  const { organizationId } = useParams();
  const { organization } = useOrganization();

  const hallWorkspaceId = matchPath(WORKSPACE_HALL_PATTERN, pathname)?.params.workspaceId;

  return hallWorkspaceId ?? (organizationId ? organization?.workspace_id : undefined);
}
